const t = {
  name: "PlusSmall",
  dimensions: { width: 11, height: 12 },
  content: `
    <g fill="none">
        <path d="M1 5.25H9" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M5 9.25L5 1.25" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
  `
};
export {
  t as PlusSmall
};
